// Mock data service for development/testing
class MockDataService {
    constructor() {
        this.profiles = [
            {
                id: 'profile-1',
                name: 'B2B Blocker Import',
                description: 'Import profile for B2B blocker orders',
                importType: 'single-customer-multiple-orders',
                fieldMapping: {
                    'Supplier SKU': 'productNumber',
                    'Quantity': 'quantity',
                    'Order': 'orderNumber',
                    'Order Date': 'orderDate',
                    'Last Name': 'lastName',
                    'First Name': 'firstName',
                    'Company': 'company',
                    'Address': 'street',
                    'Post Code': 'zipCode',
                    'City': 'city',
                    'Country': 'country'
                },
                defaultValues: {
                    salesChannelId: 'default-sales-channel',
                    paymentMethodId: 'default-payment-method',
                    countryId: 'default-country'
                },
                // Profile has predefined customer and addresses
                customer: {
                    id: 'customer-1',
                    email: 'info@kindsgut.de',
                    firstName: 'Kindsgut',
                    lastName: 'GmbH',
                    customerNumber: 'CUST001',
                    company: 'Kindsgut GmbH'
                },
                billingAddress: {
                    id: 'address-1',
                    firstName: 'Kindsgut',
                    lastName: 'GmbH',
                    company: 'Kindsgut GmbH',
                    street: 'Altonaer Straße 83A',
                    zipcode: '13581',
                    city: 'Berlin',
                    country: 'Deutschland',
                    countryId: 'germany-id'
                },
                shippingAddress: {
                    id: 'address-1',
                    firstName: 'Kindsgut',
                    lastName: 'GmbH',
                    company: 'Kindsgut GmbH',
                    street: 'Altonaer Straße 83A',
                    zipcode: '13581',
                    city: 'Berlin',
                    country: 'Deutschland',
                    countryId: 'germany-id'
                },
                active: true,
                createdAt: new Date('2024-01-15T10:00:00Z'),
                updatedAt: new Date('2024-01-20T14:30:00Z')
            },
            {
                id: 'profile-2',
                name: 'Westwing Import',
                description: 'Import profile for Westwing orders',
                importType: 'single-customer-single-order',
                fieldMapping: {
                    'Tracking Numbers': 'trackingNumber',
                    'Carrier': 'carrier',
                    'Order': 'orderNumber',
                    'Order Date': 'orderDate',
                    'Westwing SKU': 'productNumber',
                    'Product Name': 'productName',
                    'Quantity': 'quantity',
                    'Price per Item': 'unitPrice'
                },
                defaultValues: {
                    salesChannelId: 'westwing-sales-channel',
                    paymentMethodId: 'invoice-payment',
                    countryId: 'germany'
                },
                // Profile has predefined customer and addresses
                customer: {
                    id: 'customer-2',
                    email: 'test@westwing.com',
                    firstName: 'Westwing',
                    lastName: 'Customer',
                    customerNumber: 'CUST002',
                    company: 'Westwing Home & Living'
                },
                billingAddress: {
                    id: 'address-2',
                    firstName: 'Westwing',
                    lastName: 'Customer',
                    company: 'Westwing Home & Living',
                    street: 'Westwing Straße 1',
                    zipcode: '80807',
                    city: 'München',
                    country: 'Deutschland',
                    countryId: 'germany-id'
                },
                shippingAddress: {
                    id: 'address-2',
                    firstName: 'Westwing',
                    lastName: 'Customer',
                    company: 'Westwing Home & Living',
                    street: 'Westwing Straße 1',
                    zipcode: '80807',
                    city: 'München',
                    country: 'Deutschland',
                    countryId: 'germany-id'
                },
                active: true,
                createdAt: new Date('2024-02-01T09:15:00Z'),
                updatedAt: null
            },
            {
                id: 'profile-3',
                name: 'Amazon Import',
                description: 'Import profile for Amazon orders',
                importType: 'multi-customer-orders',
                fieldMapping: {
                    'Order': 'orderNumber',
                    'Order Date': 'orderDate',
                    'Supplier SKU': 'productNumber',
                    'Product Name': 'productName',
                    'Quantity': 'quantity',
                    'Price per Item': 'unitPrice',
                    'Last Name': 'lastName',
                    'First Name': 'firstName',
                    'Company': 'company',
                    'Address': 'street',
                    'Post Code': 'zipcode',
                    'City': 'city',
                    'Country': 'country'
                },
                defaultValues: {
                    salesChannelId: 'amazon-sales-channel',
                    paymentMethodId: 'amazon-payment',
                    countryId: 'germany'
                },
                // Multi-customer profile - no predefined customer/addresses
                customer: null,
                billingAddress: null,
                shippingAddress: null,
                active: false,
                createdAt: new Date('2024-03-10T16:45:00Z'),
                updatedAt: new Date('2024-03-15T11:20:00Z')
            }
        ];

        this.customers = [
            {
                id: 'customer-1',
                email: 'info@kindsgut.de',
                firstName: 'Kindsgut',
                lastName: 'GmbH',
                customerNumber: 'CUST001',
                company: 'Kindsgut GmbH',
                addresses: [
                    {
                        id: 'address-1',
                        firstName: 'Kindsgut',
                        lastName: 'GmbH',
                        company: 'Kindsgut GmbH',
                        street: 'Altonaer Straße 83A',
                        zipcode: '13581',
                        city: 'Berlin',
                        country: 'Deutschland',
                        countryId: 'germany-id'
                    }
                ]
            },
            {
                id: 'customer-2',
                email: 'test@westwing.com',
                firstName: 'Westwing',
                lastName: 'Customer',
                customerNumber: 'CUST002',
                company: 'Westwing Home & Living',
                addresses: [
                    {
                        id: 'address-2',
                        firstName: 'Westwing',
                        lastName: 'Customer',
                        company: 'Westwing Home & Living',
                        street: 'Westwing Straße 1',
                        zipcode: '80807',
                        city: 'München',
                        country: 'Deutschland',
                        countryId: 'germany-id'
                    }
                ]
            },
            {
                id: 'customer-3',
                email: 'max.mustermann@email.de',
                firstName: 'Max',
                lastName: 'Mustermann',
                customerNumber: 'CUST003',
                company: 'Mustermann GmbH',
                addresses: [
                    {
                        id: 'address-3',
                        firstName: 'Max',
                        lastName: 'Mustermann',
                        company: 'Mustermann GmbH',
                        street: 'Musterstraße 123',
                        zipcode: '12345',
                        city: 'Musterstadt',
                        country: 'Deutschland',
                        countryId: 'germany-id'
                    }
                ]
            },
            {
                id: 'customer-4',
                email: 'anna.mueller@test.de',
                firstName: 'Anna',
                lastName: 'Müller',
                customerNumber: 'CUST004',
                company: 'Müller & Partner',
                addresses: [
                    {
                        id: 'address-4',
                        firstName: 'Anna',
                        lastName: 'Müller',
                        company: 'Müller & Partner',
                        street: 'Hauptstraße 456',
                        zipcode: '10115',
                        city: 'Berlin',
                        country: 'Deutschland',
                        countryId: 'germany-id'
                    }
                ]
            },
            {
                id: 'customer-5',
                email: 'peter.mueller@firma.de',
                firstName: 'Peter',
                lastName: 'Müller',
                customerNumber: 'CUST005',
                company: 'Müller Trading',
                addresses: [
                    {
                        id: 'address-5',
                        firstName: 'Peter',
                        lastName: 'Müller',
                        company: 'Müller Trading',
                        street: 'Industriestraße 789',
                        zipcode: '40211',
                        city: 'Düsseldorf',
                        country: 'Deutschland',
                        countryId: 'germany-id'
                    }
                ]
            },
            {
                id: 'customer-6',
                email: 'schmidt@company.com',
                firstName: 'Thomas',
                lastName: 'Schmidt',
                customerNumber: 'CUST006',
                company: 'Schmidt Solutions',
                addresses: [
                    {
                        id: 'address-6',
                        firstName: 'Thomas',
                        lastName: 'Schmidt',
                        company: 'Schmidt Solutions',
                        street: 'Technikweg 12',
                        zipcode: '20095',
                        city: 'Hamburg',
                        country: 'Deutschland',
                        countryId: 'germany-id'
                    }
                ]
            }
        ];

        this.salesChannels = [
            { id: 'default-sales-channel', name: 'Headless' },
            { id: 'main-storefront', name: 'Storefront' },
            { id: 'westwing-sales-channel', name: 'Westwing Marketplace' },
            { id: 'amazon-sales-channel', name: 'Amazon Marketplace' },
            { id: 'ebay-sales-channel', name: 'eBay Marketplace' },
            { id: 'otto-sales-channel', name: 'OTTO Marketplace' },
            { id: 'zalando-sales-channel', name: 'Zalando Partner' },
            { id: 'b2b-sales-channel', name: 'B2B Portal' },
            { id: 'mobile-app-channel', name: 'Mobile App' },
            { id: 'social-commerce', name: 'Social Commerce' }
        ];

        this.paymentMethods = [
            { id: 'invoice-payment', name: 'Kauf auf Rechnung' },
            { id: 'advance-payment', name: 'Vorkasse' },
            { id: 'paypal-payment', name: 'PayPal' },
            { id: 'stripe-payment', name: 'Stripe' },
            { id: 'klarna-payment', name: 'Klarna' },
            { id: 'sepa-payment', name: 'SEPA Lastschrift' },
            { id: 'credit-card', name: 'Kreditkarte' },
            { id: 'amazon-pay', name: 'Amazon Pay' },
            { id: 'apple-pay', name: 'Apple Pay' },
            { id: 'google-pay', name: 'Google Pay' },
            { id: 'sofort-payment', name: 'Sofortüberweisung' },
            { id: 'giropay-payment', name: 'Giropay' }
        ];

        this.countries = [
            { id: 'germany-id', name: 'Deutschland', iso: 'DE' },
            { id: 'austria-id', name: 'Österreich', iso: 'AT' },
            { id: 'switzerland-id', name: 'Schweiz', iso: 'CH' },
            { id: 'france-id', name: 'Frankreich', iso: 'FR' },
            { id: 'belgium-id', name: 'Belgien', iso: 'BE' },
            { id: 'netherlands-id', name: 'Niederlande', iso: 'NL' },
            { id: 'italy-id', name: 'Italien', iso: 'IT' },
            { id: 'spain-id', name: 'Spanien', iso: 'ES' },
            { id: 'poland-id', name: 'Polen', iso: 'PL' },
            { id: 'czechia-id', name: 'Tschechien', iso: 'CZ' },
            { id: 'denmark-id', name: 'Dänemark', iso: 'DK' },
            { id: 'sweden-id', name: 'Schweden', iso: 'SE' },
            { id: 'norway-id', name: 'Norwegen', iso: 'NO' }
        ];

        // Mock products for validation
        this.products = [
            { id: 'prod-1', productNumber: 'DA00112017N', name: 'Amazon Palette Product 1' },
            { id: 'prod-2', productNumber: 'DB00012017N', name: 'Amazon Palette Product 2' },
            { id: 'prod-3', productNumber: 'DC00012017N', name: 'Amazon Palette Product 3' },
            { id: 'prod-4', productNumber: 'DD00012017N', name: 'Amazon Palette Product 4' },
            { id: 'prod-5', productNumber: 'TEST-001', name: 'Test Product 1' },
            { id: 'prod-6', productNumber: 'TEST-002', name: 'Test Product 2' },
            { id: 'prod-7', productNumber: 'WESTWING-001', name: 'Westwing Product 1' },
            { id: 'prod-8', productNumber: 'B2B-001', name: 'B2B Product 1' },
        ];
    }

    // Simulate API delay
    delay(ms = 500) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // Profile CRUD operations
    async getProfiles(searchTerm = '', active = null) {
        await this.delay();
        
        let filtered = this.profiles;
        
        if (searchTerm) {
            filtered = filtered.filter(profile => 
                profile.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                profile.description?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        
        if (active !== null) {
            filtered = filtered.filter(profile => profile.active === active);
        }
        
        return {
            success: true,
            data: filtered,
            total: filtered.length
        };
    }

    async getProfile(id) {
        await this.delay();
        
        const profile = this.profiles.find(p => p.id === id);
        if (!profile) {
            return {
                success: false,
                message: 'Profile not found'
            };
        }
        return {
            success: true,
            data: profile
        };
    }

    async createProfile(profileData) {
        await this.delay();
        
        const newProfile = {
            id: `profile-${Date.now()}`,
            ...profileData,
            createdAt: new Date(),
            updatedAt: null
        };
        
        this.profiles.push(newProfile);
        
        return {
            success: true,
            data: newProfile,
            message: 'Profile created successfully'
        };
    }

    async updateProfile(id, profileData) {
        await this.delay();
        
        const index = this.profiles.findIndex(p => p.id === id);
        if (index === -1) {
            return {
                success: false,
                message: 'Profile not found'
            };
        }
        
        this.profiles[index] = {
            ...this.profiles[index],
            ...profileData,
            updatedAt: new Date()
        };
        
        return {
            success: true,
            message: 'Profile updated successfully'
        };
    }

    async deleteProfile(id) {
        await this.delay();
        
        const index = this.profiles.findIndex(p => p.id === id);
        if (index === -1) {
            return {
                success: false,
                message: 'Profile not found'
            };
        }
        
        this.profiles.splice(index, 1);
        
        return {
            success: true,
            message: 'Profile deleted successfully'
        };
    }

    async copyProfile(id) {
        await this.delay();
        
        const originalProfile = this.profiles.find(p => p.id === id);
        if (!originalProfile) {
            return {
                success: false,
                message: 'Profile not found'
            };
        }
        
        const copiedProfile = {
            ...originalProfile,
            id: `profile-${Date.now()}`,
            name: `${originalProfile.name} (Kopie)`,
            description: originalProfile.description ? `${originalProfile.description} (Kopie)` : 'Kopie des Profils',
            createdAt: new Date(),
            updatedAt: null
        };
        
        this.profiles.push(copiedProfile);
        
        return {
            success: true,
            data: copiedProfile,
            message: 'Profile copied successfully'
        };
    }

    // Customer operations
    async getCustomers(searchTerm = '') {
        await this.delay();
        
        let filtered = this.customers;
        
        // Only search if searchTerm has 3 or more characters, or is empty
        if (searchTerm && searchTerm.length >= 3) {
            filtered = filtered.filter(customer => 
                customer.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                customer.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                customer.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                customer.company?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                customer.customerNumber?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        } else if (searchTerm && searchTerm.length < 3) {
            // Return empty result for less than 3 characters
            filtered = [];
        }
        
        return {
            success: true,
            data: filtered,
            total: filtered.length
        };
    }

    async getCustomerAddresses(customerId) {
        await this.delay();
        
        const customer = this.customers.find(c => c.id === customerId);
        if (!customer) {
            return [];
        }
        
        return customer.addresses;
    }

    // Configuration data
    async getSalesChannels() {
        await this.delay();
        return { success: true, data: this.salesChannels };
    }

    async getPaymentMethods() {
        await this.delay();
        return { success: true, data: this.paymentMethods };
    }

    async getCountries() {
        await this.delay();
        return { success: true, data: this.countries };
    }

    // Find country by name or ISO code (similar to real API)
    findCountryByName(countryName) {
        const searchName = countryName.toLowerCase().trim();
        
        // Define country mappings for mock data
        const countryMappings = {
            'deutschland': ['deutschland', 'germany', 'de'],
            'germany': ['deutschland', 'germany', 'de'],
            'de': ['deutschland', 'germany', 'de'],
            
            'österreich': ['österreich', 'austria', 'at'],
            'austria': ['österreich', 'austria', 'at'],
            'at': ['österreich', 'austria', 'at'],
            
            'belgien': ['belgien', 'belgium', 'belgië', 'belgique', 'be'],
            'belgium': ['belgien', 'belgium', 'belgië', 'belgique', 'be'],
            'belgië': ['belgien', 'belgium', 'belgië', 'belgique', 'be'],
            'belgique': ['belgien', 'belgium', 'belgië', 'belgique', 'be'],
            'be': ['belgien', 'belgium', 'belgië', 'belgique', 'be'],
            
            'schweiz': ['schweiz', 'switzerland', 'suisse', 'svizzera', 'ch'],
            'switzerland': ['schweiz', 'switzerland', 'suisse', 'svizzera', 'ch'],
            'ch': ['schweiz', 'switzerland', 'suisse', 'svizzera', 'ch'],
            
            'frankreich': ['frankreich', 'france', 'fr'],
            'france': ['frankreich', 'france', 'fr'],
            'fr': ['frankreich', 'france', 'fr'],
            
            'niederlande': ['niederlande', 'netherlands', 'nederland', 'holland', 'nl'],
            'netherlands': ['niederlande', 'netherlands', 'nederland', 'holland', 'nl'],
            'nederland': ['niederlande', 'netherlands', 'nederland', 'holland', 'nl'],
            'holland': ['niederlande', 'netherlands', 'nederland', 'holland', 'nl'],
            'nl': ['niederlande', 'netherlands', 'nederland', 'holland', 'nl']
        };
        
        const searchVariations = countryMappings[searchName] || [searchName];
        
        return this.countries.find(country => {
            const name = country.name.toLowerCase();
            const iso = country.iso.toLowerCase();
            
            // Check exact matches and variations
            for (const variation of searchVariations) {
                if (name === variation || 
                    iso === variation ||
                    name.includes(variation)) {
                    return true;
                }
            }
            
            // Fallback: partial match
            return name.includes(searchName) || iso === searchName;
        });
    }

    // CSV parsing simulation
    async parseCSVHeader(file) {
        await this.delay();
        
        // Simulate parsing based on filename
        const filename = file.name.toLowerCase();
        let headers = [];
        
        if (filename.includes('b2b') || filename.includes('blocker')) {
            headers = [
                'Tracking Numbers', 'Carrier', 'Order', 'Order Date', 'Supplier SKU',
                'Westwing SKU', 'Product Name', 'Quantity', 'Delivery Date',
                'Last Name', 'First Name', 'Company', 'Address', 'Address 2',
                'Post Code', 'City', 'Country', 'Status', 'Purchase Order',
                'Order Item ID', 'Internal Order Item ID', 'Delivery Information',
                'Price per Item'
            ];
        } else if (filename.includes('westwing')) {
            headers = [
                'Tracking Numbers', 'Carrier', 'Order', 'Order Date', 'Westwing SKU',
                'Product Name', 'Quantity', 'Price per Item', 'Customer Name',
                'Shipping Address', 'Billing Address'
            ];
        } else if (filename.includes('amazon')) {
            headers = [
                'Tracking Numbers', 'Carrier', 'Order', 'Order Date', 'Supplier SKU',
                'Westwing SKU', 'Product Name', 'Quantity', 'Delivery Date',
                'Last Name', 'First Name', 'Company', 'Address', 'Address 2',
                'Post Code', 'City', 'Country', 'Status', 'Purchase Order',
                'Order Item ID', 'Internal Order Item ID', 'Delivery Information',
                'Price per Item'
            ];
        } else {
            headers = ['Column 1', 'Column 2', 'Column 3', 'Column 4', 'Column 5'];
        }
        
        return {
            success: true,
            data: {
                headers: headers,
                filename: file.name,
                size: file.size
            }
        };
    }

    // Import simulation
    async importCSV(file, customer, address, profileId) {
        await this.delay(2000); // Longer delay for import simulation
        
        const rowCount = Math.floor(Math.random() * 50) + 10; // Random 10-60 rows
        const successCount = Math.floor(rowCount * 0.9); // 90% success rate
        const errorCount = rowCount - successCount;
        
        return {
            success: true,
            data: {
                processedRows: rowCount,
                successfulImports: successCount,
                errors: errorCount,
                ordersCreated: successCount,
                message: `Successfully imported ${successCount} orders from ${rowCount} rows`
            }
        };
    }

    async getShippingMethods() {
        await this.delay();
        
        return {
            success: true,
            data: [
                {
                    id: 'shipping-1',
                    name: 'Standard Versand'
                },
                {
                    id: 'shipping-2', 
                    name: 'Express Versand'
                },
                {
                    id: 'shipping-3',
                    name: 'DHL Paket'
                },
                {
                    id: 'shipping-4',
                    name: 'UPS Standard'
                },
                {
                    id: 'shipping-5',
                    name: 'Selbstabholung'
                }
            ]
        };
    }

    // Product validation for CSV imports
    async findProductsByNumbers(productNumbers) {
        await this.delay();
        
        if (!productNumbers || productNumbers.length === 0) {
            return { success: true, data: { products: [] } };
        }
        
        // Find products that match the provided product numbers
        const foundProducts = this.products.filter(product => 
            productNumbers.includes(product.productNumber)
        );
        
        console.log(`[Mock] Product search: ${foundProducts.length} of ${productNumbers.length} products found`);
        console.log('[Mock] Searched for:', productNumbers);
        console.log('[Mock] Found products:', foundProducts.map(p => p.productNumber));
        
        return {
            success: true,
            data: {
                products: foundProducts
            }
        };
    }

    // Mock price lookup for testing price logic
    async getProductPricesForProfile(productIds, profileSalesChannelId, customer = null, profile = null) {
        await this.delay();
        
        console.log('[Mock] Price lookup called with:', {
            productIds,
            profileSalesChannelId,
            customerId: customer?.id,
            profileName: profile?.name
        });
        
        const mockPrices = {};
        
        // Simulate different price scenarios based on sales channel and customer
        productIds.forEach((productId, index) => {
            let netPrice = 10.00 + (index * 5); // Base price
            let priceSource = 'fallback';
            
            // Simulate sales channel specific pricing
            if (profileSalesChannelId === 'limango-sales-channel') {
                netPrice = 15.00 + (index * 3); // Limango prices
                priceSource = 'sales-channel-group';
            } else if (profileSalesChannelId === 'babyone-sales-channel') {
                netPrice = 20.00 + (index * 4); // BabyOne prices
                priceSource = 'sales-channel-group';
            }
            
            // Simulate customer group pricing
            if (customer?.group?.name === 'Limango') {
                netPrice = 12.00 + (index * 2); // Limango customer group pricing
                priceSource = 'customer-group';
            } else if (customer?.group?.name === 'BabyOne') {
                netPrice = 18.00 + (index * 3); // BabyOne customer group pricing
                priceSource = 'customer-group';
            }
            
            mockPrices[productId] = {
                netPrice: netPrice,
                grossPrice: netPrice * 1.19, // 19% tax
                unitPrice: netPrice,
                totalPrice: netPrice,
                listPrice: netPrice * 1.1, // 10% higher list price
                taxRate: 19,
                ruleId: `mock-rule-${priceSource}`,
                quantityStart: 1,
                priceSource: priceSource,
                currencyId: 'EUR'
            };
        });
        
        console.log('[Mock] Generated prices:', Object.keys(mockPrices).map(productId => ({
            productId,
            priceSource: mockPrices[productId].priceSource,
            netPrice: mockPrices[productId].netPrice,
            ruleId: mockPrices[productId].ruleId
        })));
        
        return mockPrices;
    }
}

const mockDataService = new MockDataService();
export default mockDataService;